"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MessageBarGroup", {
    enumerable: true,
    get: function() {
        return MessageBarGroup;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useMessageBarGroup = require("./useMessageBarGroup");
const _renderMessageBarGroup = require("./renderMessageBarGroup");
const _useMessageBarGroupStylesstyles = require("./useMessageBarGroupStyles.styles");
const MessageBarGroup = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useMessageBarGroup.useMessageBarGroup_unstable)(props, ref);
    (0, _useMessageBarGroupStylesstyles.useMessageBarGroupStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useMessageBarGroupStyles_unstable')(state);
    return (0, _renderMessageBarGroup.renderMessageBarGroup_unstable)(state);
});
MessageBarGroup.displayName = 'MessageBarGroup';
